import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import i18next from 'i18next';

import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';

import { COLUMN_DISPLAY } from '../constants';
import { updateColumnDisplay } from '../../../redux/slices/categoryDataSlice';
import { useStyles } from './styles';
import Paper from '../../Paper';
import Checkbox from '../../Filter/Checkbox';
import { getCurrentLanguage } from '../../../utils/i18n';

const TableViewCol = ({ viewableColumns, adjustToolbarWidth }) => {
	const classes = useStyles();
	const { t } = useTranslation();
	const columns = useSelector(state => state.categoryData.columns);
	const dispatch = useDispatch();
	const lang = getCurrentLanguage();

	const handleDisplayClick = cid => {
		dispatch(updateColumnDisplay(cid));
		const tableScrollElement = document.querySelector("table[role='grid']").parentElement;
		adjustToolbarWidth(tableScrollElement);
	};

	function getOriginalColumnLabel(MDTcolumn) {
		if (lang === 'cn' && i18next.exists(`filters.${MDTcolumn.name}`)) {
			return parse(t(`filters.${MDTcolumn.name}`));
		}
		const originalColumn = columns.find(col => col.cid === MDTcolumn.name);
		return originalColumn ? parse(originalColumn.label) : MDTcolumn.label;
	}

	return (
		<Paper padding={2} className={classes.paper}>
			<FormControl component="fieldset">
				<FormLabel className={classes.formLabel}>{t('components.productsTable.text.showColumns')}</FormLabel>

				<FormGroup id="Products_Table__View_Col" className={classes.formGroup}>
					{viewableColumns.map(col => (
						<Checkbox
							color="primary"
							key={col.name + '-table-view-col-cb'}
							gutterVertical
							checked={col.display === COLUMN_DISPLAY.TRUE}
							onClick={() => handleDisplayClick(col.name)}
							label={getOriginalColumnLabel(col)}
							name={col.name}
						/>
					))}
				</FormGroup>
			</FormControl>
		</Paper>
	);
};

TableViewCol.propTypes = {
	viewableColumns: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default TableViewCol;
